import {createFeature} from "@ngrx/store";
import {trainingReducer} from "./training-reducer";

export const trainingFeature = createFeature({
    name: 'training',
    reducer: trainingReducer
});
